import { ScrollPage } from "@appidea/react-scroll-motion";
import { Message } from "@messageformat/react";
import stoisko from "../../assets/stoisko.jpg";
import styles from "./Trust.module.scss";
import fenicja from "../../assets/fenicja_logo.png";
import classnames from "classnames";
import { colors } from "../../../colors";

const Trust = ({ page }) => {
  return (
    <div
      className={styles.pageContainer}
      style={{
        backgroundColor: colors.grayLight,
      }}
    >
      <img src={stoisko} alt="stoisko" className={styles.backgroundImage} />
      <div className={styles.overlay}></div>
      <div className={styles.container}>
        <div
          className={classnames(
            styles.roundContainer,
            styles.roundContainerText,
          )}
        >
          <h2 className={styles.roundContainerTextHeader}>
            <Message id="landingPage.trust.title" />
          </h2>
          <p className={styles.description}>
            <Message id="landingPage.trust.description1" />
          </p>
          <p className={styles.description}>
            <Message id="landingPage.trust.description2" />
          </p>
          <p className={styles.eventInfo}>
            <Message id="landingPage.trust.eventInfo" />
          </p>
        </div>

        <div className={styles.trustedSection}>
          <p className={styles.trustedTitle}>
            <strong>
              <Message id="landingPage.trust.trustedBy" />
            </strong>
          </p>

          <div className={styles.roundContainer}>
            <img src={fenicja} alt="Fenicja" className={styles.logoImage} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Trust;
